import getConfig from 'next/config';

export const isProduction = (): boolean => {
  const memriseEnv = getConfig()?.publicRuntimeConfig?.MEMRISE_ENV;
  return memriseEnv === 'production';
};
